import { Environment } from './types/environment.type';

/**
 * Development environment configuration.
 * Used when running `ng serve` with the `development` configuration.
 *
 * NOTE: Do NOT place secrets or API tokens here — use environment.local.ts instead.
 * Values are injected at build time via Azure Pipeline token replacement.
 *
 * Okta issuer and clientId are supplied dynamically by the backend at runtime.
 * Only PlatformApiBaseUrl needs to be injected by the pipeline.
 */
export const environment: Environment = {
  development: true,
  platformApiBaseUrl: 'https://cnc.api.dtims.ai',
  okta: {
    oktaStorageKey: 'okta-token-storage-licensing'
  }
};
